module.exports = __webpack_public_path__ + "img/avatar.a5f0b059.jpg";